import React from "react";
import { Props } from "./types";
import { Group } from "./group";
import styles from "./styles.scss";

function GroupList(props: Props) {
  return (
    <ul className={styles.groupList}>
      {props.groups.map((group) => (
        <li className={styles.group}>
          <Group
            group={group}
            isSelected={
              !!props.selectedGroups.find(({ uuid }) => uuid === group.uuid)
            }
            select={props.select}
            unSelect={props.unSelect}
          />
        </li>
      ))}
    </ul>
  );
}

export { GroupList };
